import IDENTIFICATION_CARD_FRONT from './IdentificationCardFront'
import IDENTIFICATION_CARD_BACK from './IdentificationCardBack'

export default {
  FRONT: IDENTIFICATION_CARD_FRONT,
  BACK: IDENTIFICATION_CARD_BACK,
}
